export default __webpack_public_path__ + "static/media/backgroundverde.8559635b.jpg";